<template>
  <div>
    <div class="portlet light portlet-fit quote-details-portlet" @keydown="downKeyAdd">
      <div class="portlet-title">
        <div class="caption">
          <i class="fa fa-list"></i>
          <span class="caption-subject bold uppercase">Services et pièces</span>
        </div>
        <div class="tools">
          <a href="javascript:;" class="collapse" data-original-title="" title='Afficher / Cacher'> </a>
        </div>
        <div style="text-align: right;" v-if="!readOnly">
          <a href="javascript:;" class="btn green" v-if="priceIsVisible" @click="togglePriceVisibility"><span class="fa fa-check-square-o"> </span> Visibilité prix </a>
          <a href="javascript:;" class="btn red" v-else @click="togglePriceVisibility"><span class="fa fa-square-o"> </span> Visibilité prix </a>
          <!-- <a href="javascript:;" class="btn red" v-if="isDifferent" @click="cancelChanges"><span class="fa fa-times"> </span> Annuler les changements </a>
          <a href="javascript:;" class="btn purple" v-if="isDifferent" @click="saveItems"><span class="fa fa-save"> </span> Enregistrer les changements </a> -->
        </div>
        <div style="text-align: right;" v-else>
          <a href="javascript:;" class="btn green" v-if="priceIsVisible" @click="togglePriceVisibility"><span class="fa fa-check-square-o"> </span> Visibilité prix </a>
          <a href="javascript:;" class="btn red" v-else @click="togglePriceVisibility"><span class="fa fa-square-o"> </span> Visibilité prix </a>
        </div>
      </div>
      <div class="portlet-body">
        <div v-if="loading">
          <div class="text-center">
            <span style="font-size: 22px"><i class="fa fa-refresh fa-spin"></i></span>
          </div>
        </div>
        <div v-else>
          <table id="quote-details-table" class="table table-bordered" style="margin-bottom: 5px">
            <thead>
              <tr>
                <th v-if="!readOnly">&nbsp;</th>
                <th v-if="!readOnly">&nbsp;</th>
                <th class="width-min-nowrap">Choisi</th>
                <!--<th>&nbsp;</th>-->
                <th>Items</th>
                <th>Description</th>
                <th>Fournisseur</th>
                <th class="width-min-nowrap">Stock</th>
                <th class="width-min-nowrap">Quantité</th>
                <th class="width-min-nowrap">$ suggéré<wbr>unitaire</th>
                <th class="width-min-nowrap" v-if="priceIsVisible">$ coutant<wbr>unitaire</th>
                <th class="text-left" v-if="priceIsVisible" style="max-width: 83px">Profit $ min</th>
                <th class="width-min-nowrap" v-if="priceIsVisible">Profit %<wbr>min</th>
                <th class="text-left nowrap" style="max-width: 83px">$ vendant<wbr>unitaire</th>
                <th class="width-min-nowrap" v-if="priceIsVisible">Profit %<wbr>réel</th>
                <th class="width-min-nowrap text-right">S-Total</th>
                <!-- <th class="width-min-nowrap text-right">TPS</th>
                <th class="width-min-nowrap text-right">TVQ</th> -->
                <th class="width-min-nowrap text-right">Total</th>
              </tr>
            </thead>
            <draggable v-model="items" tag="tbody" handle=".draggable-handle" @update="saveItems">
              <tr v-for="(item, index) in items" v-bind:key="index" class="item-row" :class="{'item-unselected':!item.quote_detail_selected,'item-subtotal':item.quote_detail_row_subtotal}">
                <td class="width-min-nowrap draggable-handle" v-if="!readOnly" style="padding: 3px 8px; vertical-align: middle; font-size: 22px; cursor:move">
                  <i class="fa fa-bars"></i>
                </td>
                <td class="width-min-nowrap" v-if="!readOnly" style="padding: 3px 8px">
                  <a class="btn btn-circle btn-icon-only btn-default tooltips" @click="removeItem(index)" data-container="body" data-placement="top" data-original-title='Supprimer' href="javascript:;">
                    <i class="icon-trash"></i>
                  </a>
                </td>
                <td class="width-min-nowrap cb">
                  <div v-if="!item.quote_detail_row_subtotal">                  
                    <div v-if="!readOnly && !item.quote_detail_row_subtotal">
                      <input class="quote_detail_selected" type="checkbox" v-model="item.quote_detail_selected" @change="handleChange">
                    </div>
                    <div v-else>
                      <i v-if="item.quote_detail_selected" class="fa fa-check-square-o" style="font-size: 18px;"></i>
                      <i v-else class="fa fa-square-o" style="font-size: 18px;"></i>
                    </div>
                  </div>
                </td>
                <!--
                <td class="width-min-nowrap" style="vertical-align: top;">
                  <span v-if="item.quote_detail_service_id != null" title="Service">S</span>
                  <span v-else-if="item.quote_detail_part_id != null" title="Pièce">P</span>
                  <span v-else-if="item.quote_detail_quote_item_id != null" title="Item de soumission">I</span>
                  <span v-else title="Autre">A</span>
                </td>
                -->
                <td v-if="!item.quote_detail_row_subtotal" class="input" style="width: 350px; min-width: 350px;">
                  <div v-if="!readOnly">
                    <select-two-items 
                      :id="'select2-item-'+index" 
                      :endpoint="itemEndpoint" 
                      type="all" 
                      v-model="item.quote_detail_item" 
                      @selected="onSelect(index, $event)" 
                      @clear="onClear(index)" 
                      :ref="'select2-item-'+index" 
                      :initial-value="(item.quote_detail_item.id)?item.quote_detail_item.id.toString():''"  
                      :initial-display="item.quote_detail_item.text"
                      :add-form-base-end-point="baseEndpoint+'quote_item/add'"
                      :add-form-title="'Ajout d\'un item'"
                      :add-form-selector="'#form_quote_item'"
                      :add-text-input-selector="'#quote_item_name'"
                      :edit-form-base-end-point="baseEndpoint+'quote_item/edit'"
                      :edit-form-title="'Modifier un item'"
                      :edit-form-selector="'#form_quote_item'"
                      :edit-text-input-selector="'#quote_item_name'"
                      :allow-add="allowAddItems"
                      :allow-edit="allowEditItems" 
                    />
                  </div>
                  <div v-else style="padding: 5px;">
                    {{item.quote_detail_item.text}}
                  </div>
                </td>                
                <td v-else  class="bold" style="width: 350px; min-width: 350px;">
                  Sous-Total
                    <input  type="hidden" v-model="item.quote_detail_row_subtotal">
                </td>     
                <td class="input">
                  <div v-if="!readOnly">
                    <textarea ref="description-box" class="form-control" style="width:100%; height: 35px; min-height: 35px; resize: vertical" v-model="item.quote_detail_description" @change="handleChangeLine(item)" @input="autoResize"></textarea>
                  </div>
                  <div v-else style="padding: 5px;" v-html="item.quote_detail_description.replace(/\n/g, '<br>')"></div>
                </td>
                <td class="input" style="width: 150px; max-width: 150px;">
                  <div v-if="!readOnly && !item.quote_detail_row_subtotal">
                    <select-two-suppliers :id="'select2-supplier-'+index" :endpoint="supplierEndpoint" v-model="item.quote_detail_supplier" @selected="onSelectSupplier(index, $event)" @clear="onClearSupplier(index)" 
                    :initial-value="item.quote_detail_supplier.id" :initial-display="item.quote_detail_supplier.text"></select-two-suppliers>
                  </div>
                  <div v-else style="padding: 5px;">
                    {{item.quote_detail_supplier.text}}
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal" class="width-min-nowrap cb">
                  <div v-if="!readOnly && !item.quote_detail_row_subtotal">
                    <input class="quote_detail_in_stock" type="checkbox" v-model="item.quote_detail_in_stock" @change="handleChange">
                  </div>
                  <div v-else>
                    <i v-if="item.quote_detail_in_stock" class="fa fa-check-square-o" style="font-size: 18px;"></i>
                    <i v-else class="fa fa-square-o" style="font-size: 18px;"></i>
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal" class="width-min-nowrap input" style="width: 78px">
                  <div v-if="!readOnly && !item.quote_detail_row_subtotal">
                    <input style="width: 78px; padding-right: 5px; padding-left: 5px" class="form-control quote_detail_qty select-on-focus" type="number" v-model="item.quote_detail_qty" @change="handleChangePricing(index, item)">
                  </div>
                  <div v-else style="padding: 5px; text-align: right;">
                    {{item.quote_detail_qty}}
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal" class="width-min-nowrap input" style="width: 78px; position: relative">
                  <div v-if="!readOnly && !item.quote_detail_row_subtotal">
                    <span style="position: absolute; top: 8px; right: 8px; font-size: 16px; user-select: none">$</span>
                    <input style="width: 78px; padding-right: 20px; padding-left: 5px" class="form-control quote_detail_suggested_price text-right select-on-focus" type="text" v-model="item.quote_detail_suggested_price" @blur="fixPrice(item, index, $event.target)" @change="handleChangePricing(index, item)">
                  </div>
                  <div v-else style="padding: 5px; text-align: right;">
                    {{item.quote_detail_suggested_price}} $
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal && priceIsVisible" class="width-min-nowrap input" style="width: 78px; position: relative">
                  <div v-if="!readOnly && !item.quote_detail_row_subtotal">
                    <span style="position: absolute; top: 8px; right: 8px; font-size: 16px; user-select: none">$</span>
                    <input style="width: 78px; padding-right: 20px; padding-left: 5px" class="form-control quote_detail_cost_price text-right select-on-focus" type="text" v-model="item.quote_detail_cost_price" @blur="fixPrice(item, index, $event.target)" @change="handleChangePricing(index, item)">
                  </div>
                  <div v-else style="padding: 5px; text-align: right;">
                    {{item.quote_detail_cost_price}} $
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal && priceIsVisible" class="width-min-nowrap input" style="width: 78px; position: relative">
                  <div v-if="!readOnly">
                    <span style="position: absolute; top: 8px; right: 8px; font-size: 16px; user-select: none">$</span>
                    <input style="width: 78px; padding-right: 20px; padding-left: 5px" class="form-control quote_detail_profit_minimum text-right select-on-focus" type="text" v-model="item.quote_detail_profit_minimum" @blur="fixPrice(item, index, $event.target)" @change="handleChangePricing(index, item)">
                  </div>
                  <div v-else style="padding: 5px; text-align: right;">
                    {{item.quote_detail_profit_minimum}} $
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal && priceIsVisible" class="width-min-nowrap input" style="width: 78px; position: relative">
                  <div v-if="!readOnly">
                    <span style="position: absolute; top: 8px; right: 8px; font-size: 16px; user-select: none">%</span>
                    <input style="width: 78px; padding-right: 20px; padding-left: 5px" class="form-control quote_detail_profit_percentage text-right select-on-focus" type="text" v-model="item.quote_detail_profit_percentage" @blur="fixPrice(item, index, $event.target)" @change="handleChangePricing(index, item)">
                  </div>
                  <div v-else style="padding: 5px; text-align: right;">
                    {{item.quote_detail_profit_percentage}} %
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal" class="width-min-nowrap input" style="width: 78px; position: relative">
                  <div v-if="!readOnly && !item.quote_detail_row_subtotal">
                    <span style="position: absolute; top: 8px; right: 8px; font-size: 16px; user-select: none">$</span>
                    <input style="width: 78px; padding-right: 20px; padding-left: 5px" class="form-control quote_detail_selling_price text-right select-on-focus" type="text" v-model="item.quote_detail_selling_price" @blur="fixPrice(item, index, $event.target)" @change="handleChangeLine(item)">
                  </div>
                  <div v-else style="padding: 5px; text-align: right;">
                    {{item.quote_detail_selling_price}} $
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal && priceIsVisible" class="width-min-nowrap input" style="width: 78px; position: relative">
                  <div v-if="!readOnly && !item.quote_detail_row_subtotal">
                    <span style="position: absolute; top: 8px; right: 8px; font-size: 16px; user-select: none">%</span>
                    <input style="width: 78px; padding-right: 20px; padding-left: 5px" class="form-control text-right quote_detail_profit_percentage_real select-on-focus" 
                        type="text" :value="getItemProfitPercent(item)" disabled>
                  </div>
                  <div v-else style="padding: 5px; text-align: right;">
                    {{getItemProfitPercent(item)}} %
                  </div>
                </td>
                <td v-if="!item.quote_detail_row_subtotal" class="width-min-nowrap text-right" style="min-width: 70px;">
                  {{getItemSubtotal(item)}} $
                </td>
                <td v-else colspan="9" class="bold text-right">
                  {{getSubTotal(index)}} $
                </td>
                <!-- <td class="width-min-nowrap cb">
                  <div v-if="!readOnly">
                    <input class="quote_detail_taxable_tps" type="checkbox" v-model="item.quote_detail_taxable_tps" @change="handleChange">
                  </div>
                  <div v-else>
                    <i v-if="item.quote_detail_taxable_tps" class="fa fa-check-square-o" style="font-size: 18px;"></i>
                    <i v-else class="fa fa-square-o" style="font-size: 18px;"></i>
                  </div>
                </td>
                <td class="width-min-nowrap cb">
                  <div v-if="!readOnly">
                    <input class="quote_detail_taxable_tvq" type="checkbox" v-model="item.quote_detail_taxable_tvq" @change="handleChange">
                  </div>
                  <div v-else>
                    <i v-if="item.quote_detail_taxable_tvq" class="fa fa-check-square-o" style="font-size: 18px;"></i>
                    <i v-else class="fa fa-square-o" style="font-size: 18px;"></i>
                  </div>
                </td> -->
                <td v-if="!item.quote_detail_row_subtotal" class="width-min-nowrap text-right" style="min-width: 70px;" :style="{'text-decoration':item.quote_detail_selected ? 'none' : 'line-through'}">
                  {{getItemTotal(item)}} $
                </td>
                <td v-else class="width-min-nowrap bold text-right" style="min-width: 70px;" :style="{'text-decoration':item.quote_detail_selected ? 'none' : 'line-through'}">
                  {{getTotal(index)}} $
                </td>
              </tr>
            </draggable>
          </table>
          <div>
            <div style="float: left;">
              <button v-if="!readOnly" class="btn purple" @click="addItem"><i class="fa fa-plus"></i> Ajouter une ligne</button>
            </div>
            <div style="float: left; margin-left: 10px;">
              <button v-if="!readOnly" class="btn purple" @click="addSubtotal"><i class="fa fa-plus"></i> Ajouter un sous-total</button>
            </div>
            <div style="float: right;">
              <table class="table-bordered text-right">
                <tr>
                  <td style="padding: 5px;">Total sans taxes:</td>
                  <td style="padding: 5px;">{{round(subtotal,2)}} $</td>
                </tr>
                <tr>
                  <td style="padding: 5px;">Montant taxable TPS:</td>
                  <td style="padding: 5px;">{{round(taxableTpsAmount,2)}} $</td>
                </tr>
                <tr>
                  <td style="padding: 5px;">TPS ({{tpsValue}} %):</td>
                  <td style="padding: 5px;">{{round(tpsAmount,2)}} $</td>
                </tr>
                <tr>
                  <td style="padding: 5px;">Montant taxable TVQ:</td>
                  <td style="padding: 5px;">{{round(taxableTvqAmount,2)}} $</td>
                </tr>
                <tr>
                  <td style="padding: 5px;">TVQ ({{tvqValue}} %):</td>
                  <td style="padding: 5px;">{{round(tvqAmount,2)}} $</td>
                </tr>
                <tr>
                  <td style="padding: 5px; font-weight: bold;">Total:</td>
                  <td style="padding: 5px; min-width: 100px; font-weight: bold;">{{round(grandTotal,2)}} $</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { send } from 'q';
import draggable from 'vuedraggable';

export default {
  name: "quote-detail-list",
  components: {
    draggable,
  },
  props: {
    quoteId: {
      type: String,
      required: true
    },
    baseEndpoint: {
      type: String,
      required: true
    },
    tpsValue: {
      type: Number,
      required: true
    },
    tvqValue: {
      type: Number,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    allowEditItems: {
      type: Boolean,
      default: true
    },
    allowAddItems: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      items: [],
      oldItems: [],
      loading: true,
      priceIsVisible: true,
    }
  },
  mounted(){
    this.loadItems();
    $(".quote-details-portlet").on("focus", "input.select-on-focus", function() {
      $(this).trigger("select");
    })
  },
  computed:{
    itemEndpoint: function(){
      return this.baseEndpoint + "quote/select2/allitems";
    },
    supplierEndpoint: function(){
      return this.baseEndpoint + "quote/select2/allsuppliers";
    },
    isDifferent: function(){
      return JSON.stringify(this.items) != JSON.stringify(this.oldItems);
    },
    subtotal: function(){
      var value = 0;
      this.items.forEach(function(itm){
        if(itm.quote_detail_selected){
          value += parseFloat(itm.quote_detail_selling_price) * parseFloat(itm.quote_detail_qty);
        }
      });
      return value;
    },
    taxableTpsAmount: function(){
      var value = 0;
      this.items.forEach(function(itm){
        if(itm.quote_detail_taxable_tps && itm.quote_detail_selected){
          value += parseFloat(itm.quote_detail_selling_price) * parseFloat(itm.quote_detail_qty);
        }
      });
      return value;
    },
    tpsAmount: function(){
      var value = parseFloat(this.taxableTpsAmount) * (this.tpsValue/100);
      return value;
    },
    taxableTvqAmount: function(){
      var value = 0;
      this.items.forEach(function(itm){
        if(itm.quote_detail_taxable_tvq && itm.quote_detail_selected){
          value += parseFloat(itm.quote_detail_selling_price) * parseFloat(itm.quote_detail_qty);
        }
      });
      return value;
    },
    tvqAmount: function(){
      var value = parseFloat(this.taxableTvqAmount) * (this.tvqValue/100);
      return value;
    },
    grandTotal: function(){
      var value = parseFloat(this.subtotal) + parseFloat(this.tpsAmount) + parseFloat(this.tvqAmount);
      return value;
    }
  },
  methods:{
    loadItems: function(){
      var that = this;
      $.get(`${this.baseEndpoint}quote/view/${this.quoteId}/details`, function(data) {
        that.items = data;
        that.loading = false;

        data.forEach(function(res){
          if(res.quote_detail_service_id == "0") res.quote_detail_service_id = null;
          if(res.quote_detail_part_id == "0") res.quote_detail_part_id = null;
          if(res.quote_detail_quote_item_id == "0") res.quote_detail_quote_item_id = null;
          if(res.quote_detail_supplier_id == "0") res.quote_detail_supplier_id = null;

          res.quote_detail_row_subtotal = res.quote_detail_row_subtotal == "1";
          res.quote_detail_taxable_tps = res.quote_detail_taxable_tps == "1";
          res.quote_detail_taxable_tvq = res.quote_detail_taxable_tvq == "1";
          res.quote_detail_in_stock = res.quote_detail_in_stock == "1";
          res.quote_detail_selected = res.quote_detail_selected == "1";

          // Items
          if(res.quote_detail_service_id != null){
            res.quote_detail_item = {
              id: "service-"+res.quote_detail_service_id,
              item_id: res.quote_detail_service_id,
              text: res.service_name,
              type: "service"
            };
          }
          else if(res.quote_detail_part_id != null){
            res.quote_detail_item = {
              id: "part-"+res.quote_detail_part_id,
              item_id: res.quote_detail_part_id,
              text: res.part_name,
              type: "part"
            };
          }
          else if(res.quote_detail_quote_item_id != null){
            res.quote_detail_item = {
              id: "quote_item-"+res.quote_detail_quote_item_id,
              item_id: res.quote_detail_quote_item_id,
              text: res.quote_item_name,
              type: "quote_item"
            };
          }
          else{
            res.quote_detail_item = {
              id: null,
              item_id: null,
              text: "",
              type: null
            };
          }
          
          // Supplier
          if(res.quote_detail_supplier_id != null){
            res.quote_detail_supplier = {
              id: res.quote_detail_supplier_id,
              text: res.supplier_name
            };
          }
          else{
            res.quote_detail_supplier = {
              id: null,
              text: ""
            };
          }
        })
        
        that.oldItems = JSON.parse(JSON.stringify(that.items));

        setTimeout(() => {
          that.autoResize();
        }, 500);
      }, "json")
    },
    autoResize() {
      if(this.$refs["description-box"] !== undefined){
        for (const textarea of this.$refs["description-box"]) {
          textarea.style.height = "10px";
          textarea.style.height = (textarea.scrollHeight+2) + "px";
        }
      }
    },
    round: function(number, precision){
      number += 0.00000001;
      return number.toFixed(2);
    },
    saveItems(){
      var that = this;
      var message_text = "<h1>Enregistrement...<br>Veuillez patienter</h1>";
      $.post(this.baseEndpoint + "quote/view/"+this.quoteId+"/details/save", {data: this.items}, function(){})
    },
    downKeyAdd(ev){
      if(ev.keyCode == '40'){
        ev.preventDefault();
        this.addItem();
      }
    },
    addItem(){
      var that = this;
      this.items.push({
        quote_detail_row_subtotal: false,
        quote_detail_id: null,
        quote_detail_item: {id:null, item_id: null, text:"", type:null},
        quote_detail_supplier: {id:null, text:""},
        quote_detail_part_id: null,
        quote_detail_service_id: null,
        quote_detail_quote_item_id: null,
        quote_detail_supplier_id: null,
        quote_detail_quote_id: that.quoteId,
        quote_detail_description: "",
        quote_detail_suggested_price: "0.00",
        quote_detail_cost_price: "0.00",
        quote_detail_selling_price: "0.00",
        quote_detail_qty: "1.00",
        quote_detail_in_stock: true,
        quote_detail_selected: true,
        quote_detail_taxable_tps: true,
        quote_detail_taxable_tvq: true,
        quote_detail_profit_percentage: null,
        quote_detail_profit_minimum: null,
      });

      setTimeout(() => {
        var count = that.items.length;
        that.$refs["select2-item-"+(count-1)][0].openFocus = true;
      }, 50)

    },
    addSubtotal(){
      var that = this;
      that.items.push({
        quote_detail_row_subtotal: true,
        quote_detail_id: null,
        quote_detail_item: {id:null, item_id: null, text:"", type:null},
        quote_detail_supplier: {id:null, text:""},
        quote_detail_part_id: null,
        quote_detail_service_id: null,
        quote_detail_quote_item_id: null,
        quote_detail_supplier_id: null,
        quote_detail_quote_id: that.quoteId,
        quote_detail_description: "",
        quote_detail_suggested_price: "0.00",
        quote_detail_cost_price: "0.00",
        quote_detail_selling_price: "0.00",
        quote_detail_qty: "0",
        quote_detail_in_stock: true,
        quote_detail_selected: true,
        quote_detail_taxable_tps: true,
        quote_detail_taxable_tvq: true
      });
      that.saveItems();
    },
    removeItem(ix){
      let _this = this;
      bootbox.dialog({
        title: "Supprimer un item",
        message: "Êtes-vous sûr de supprimer cet item?",
        buttons: {				
          remove: {
            label: L('YES_WORD'),
            className: "btn-danger",
            callback: function() {
              _this.items.splice(ix, 1);
              _this.saveItems();
            }
          },					
          cancel: {
            label: L("CANCEL"),
            className: "btn",
            callback: function() {

            }
          }
        }
      })
    },
    fixPrice(item, index, sender){
      if(item.quote_detail_suggested_price == undefined || item.quote_detail_suggested_price == "") item.quote_detail_suggested_price = "0";
      if(item.quote_detail_cost_price == undefined || item.quote_detail_cost_price == "") item.quote_detail_cost_price = "0";
      if(item.quote_detail_selling_price == undefined || item.quote_detail_selling_price == "") item.quote_detail_selling_price = "0";
      if(item.quote_detail_profit_percentage == undefined || item.quote_detail_profit_percentage == "") item.quote_detail_profit_percentage = "0";

      item.quote_detail_suggested_price = item.quote_detail_suggested_price.toString().replace(/[^\d.-]/g,'');
      item.quote_detail_cost_price = item.quote_detail_cost_price.toString().replace(/[^\d.-]/g,'');
      item.quote_detail_selling_price = item.quote_detail_selling_price.toString().replace(/[^\d.-]/g,'');
      item.quote_detail_profit_percentage = item.quote_detail_profit_percentage.toString().replace(/[^\d.-]/g,'');

      item.quote_detail_suggested_price = parseFloat(item.quote_detail_suggested_price).toFixed(2);
      item.quote_detail_cost_price = parseFloat(item.quote_detail_cost_price).toFixed(2);
      item.quote_detail_selling_price = parseFloat(item.quote_detail_selling_price).toFixed(2);
    },
    getItemSubtotal(item){
      return (item.quote_detail_selling_price * item.quote_detail_qty).toFixed(2);
    },
    getItemProfitPercent(item){
      if(item.quote_detail_selling_price == 0 && item.quote_detail_cost_price == 0) return (0).toFixed(2);
      return ((item.quote_detail_selling_price / item.quote_detail_cost_price * 100)-100).toFixed(2);
    },
    getItemTotal(item){
      var subtotal = parseFloat(this.getItemSubtotal(item));
      var tps = 0;
      if(item.quote_detail_taxable_tps){
        tps = subtotal * this.tpsValue / 100;
      }
      var tvq = 0;
      if(item.quote_detail_taxable_tvq){
        tvq = subtotal * this.tvqValue / 100;
      }
      var total = subtotal + tps + tvq;
      return (Math.round(total * 100) / 100).toFixed(2);
    },
    getSubTotal(index){
      let that = this;
      var list = that.items;
      if (list.count<index || index==0) {
        return null;
      }
      let total = 0;
      list.every(function(aitem, i){
        if (i >= index){
          return false;
        }
        if (aitem.quote_detail_row_subtotal) {
          total = 0;
          return true;
        } 
        if (aitem.quote_detail_selected) {
          total+=parseFloat(that.getItemSubtotal(aitem));
        }
        return true;
      });
      return (Math.round(total * 100) / 100).toFixed(2);
    },
    getTotal(index){ 
      let that = this;
      var list = that.items;
      if (list.count<index || index==0) {
        return null;
      }
      let total = 0;
      list.every(function(aitem, i){
        if (i >= index){
          return false;
        }
        if (aitem.quote_detail_row_subtotal) {
          total = 0;
          return true;
        } 
        if (aitem.quote_detail_selected) {
          total+=parseFloat(that.getItemTotal(aitem));
        }
        return true;
      });
      return (Math.round(total * 100) / 100).toFixed(2);
    },
    copySuggestedToSellingPrice(item) {
      //disabled depuis demande min profit item.quote_detail_selling_price = item.quote_detail_suggested_price;
    },
    togglePriceVisibility(){
      this.priceIsVisible = !this.priceIsVisible;
    },
    onSelectSupplier(index, item){
      var split = item.id.toString().split("-");
      var id = split[1];
      this.items[index].quote_detail_supplier_id = id;
      this.handleChange();
      this.$forceUpdate();
    },
    onClearSupplier(index){
      this.items[index].quote_detail_supplier_id = null;
      this.$forceUpdate();
    },
    onSelect(index, item){
      var split = item.id.toString().split("-");
      var id = split[1];
      var type = split[0];
      if(type === "service"){
        this.items[index].quote_detail_part_id = null;
        this.items[index].quote_detail_service_id = id;
        this.items[index].quote_detail_quote_item_id = null;
      }
      else if(type === "part"){
        this.items[index].quote_detail_part_id = id;
        this.items[index].quote_detail_service_id = null;
        this.items[index].quote_detail_quote_item_id = null;
      }
      else if(type === "quote_item"){
        this.items[index].quote_detail_part_id = null;
        this.items[index].quote_detail_service_id = null;
        this.items[index].quote_detail_quote_item_id = id;
        this.items[index].quote_detail_qty = (Math.round(item.quote_item_quantity_fixed*100)/100).toFixed(2);
        this.items[index].quote_detail_profit_minimum = item.quote_item_profit_minimum;
        this.items[index].quote_detail_profit_percentage = item.quote_item_profit_percentage;
      }
      this.items[index].quote_detail_description = item.description;
      if (item.price == item.cost_price && (item.quote_item_profit_minimum == 0 || item.quote_item_profit_minimum == undefined))
      {
        this.items[index].quote_detail_selling_price = item.suggested_price;
      } else {
        this.items[index].quote_detail_selling_price = item.price;
      }
      this.items[index].quote_detail_suggested_price = item.suggested_price;
      this.items[index].quote_detail_cost_price = item.cost_price;

      this.handleChange();
      this.$forceUpdate();
    },
    onClear(index){
      this.items[index].quote_detail_part_id = null;
      this.items[index].quote_detail_service_id = null;
      this.items[index].quote_detail_quote_item_id = null;
      this.$forceUpdate();
    },
    cancelChanges(){
      let _this = this;
      bootbox.dialog({
        title: "Annuler les changements",
        message: "Êtes-vous sûr d'annuler les changements courants?",
        buttons: {				
          remove: {
            label: L('YES_WORD'),
            className: "btn-danger",
            callback: function() {
              _this.items = JSON.parse(JSON.stringify(_this.oldItems));
            }
          },					
          cancel: {
            label: L("CANCEL"),
            className: "btn",
            callback: function() {

            }
          }
        }
      })
    },
    handleChangeLine(item) {
      this.handleChange()
    },
    handleChange() {
      this.saveItems();
    },
    isNone(value) {
      return value === null || value === undefined || value === "" || parseFloat(value) == 0 || value == NaN;
    },
    handleChangePricing(index, item){
      let profit_percentage = item.quote_detail_profit_percentage;
      let profit_minimum = item.quote_detail_profit_minimum;
      let suggested = item.quote_detail_suggested_price;
      let cost = item.quote_detail_cost_price;

      var selling = 0;

      if (this.isNone(profit_percentage) && this.isNone(profit_minimum)) {
        selling = parseFloat(suggested);
      } else if (this.isNone(profit_percentage)){
        selling = parseFloat(cost) + parseFloat(profit_minimum);
      } else if (this.isNone(profit_minimum)){
        selling = parseFloat(cost) * (parseFloat(profit_percentage) / 100 + 1);
      } else {
        var result_profit_percentage = parseFloat(cost) * (parseFloat(profit_percentage) / 100 + 1);
        var result_profit_minimum = parseFloat(cost) + parseFloat(profit_minimum);
        var max = Math.max(result_profit_percentage, result_profit_minimum);

        selling = max;
      }

      item.quote_detail_selling_price = selling.toFixed(2);
      this.items[index].quote_detail_selling_price = selling.toFixed(2);

      this.handleChange();
    }
  }
}
</script>

<style lang="scss">
.quote-details-portlet{
  td.input{
    padding: 2px !important;
  }

  td.cb{
    text-align: center;
  }

  td.cb input{
    width: 18px;
    height: 18px;
  }

  .width-min-nowrap{
    width: 1%;
    white-space: nowrap;
  }
  
  .item-row{
    background-color: rgb(255, 255, 255) !important;
    &:hover{
      background-color: rgb(204, 232, 255) !important;
    }
  }

  .item-row.item-unselected{
    background-color: rgb(189, 189, 189) !important;
    &:hover{
      background-color: rgb(216, 216, 216) !important;
    }
  }

  .item-row.item-subtotal {
    background-color: rgb(240, 240, 240) !important;
    &:hover{
      background-color: rgb(230, 230, 230) !important;
    }
  }
}
</style>